import { useCallback } from 'react';
import { useDevicePanel } from '@ubnt/link-core-ui/components/BottomPanel/context/DevicePanelContext';
import { useDispatch, useSelector } from 'app/store';
import { devicesDeviceInstanceSelector, devicesDeviceMountSelector, devicesMountToggle } from 'modules/devices/slice';
import { trackEvent } from 'utils/googleAnalytics';
import MountSwitch, { MountSwitchProps } from 'modules/bottomPanel/components/elements/MountSwitch';
import { resolveMountSwitchMount } from './resolveMountSwitchMount';

export interface MountSwitchContainerProps extends Partial<MountSwitchProps> {
  id: string;
}

const MountSwitchWithIdContainer = (props: MountSwitchContainerProps) => {
  const { id } = props;

  const dispatch = useDispatch();

  const onClick = useCallback(() => {
    dispatch(devicesMountToggle({ id }));
    trackEvent('bottomPanelMountToggle');
  }, [dispatch, id]);

  const mount = useSelector((state) => devicesDeviceMountSelector(state, id));
  const deviceInstance = useSelector((state) => devicesDeviceInstanceSelector(state, id));
  const mountCapabilities = deviceInstance?.mount;
  const switchMount = resolveMountSwitchMount(mount, mountCapabilities);

  return switchMount ? <MountSwitch mount={switchMount} onClick={onClick} /> : null;
};

const MountSwitchContainer = () => {
  const { id } = useDevicePanel();

  if (!id) {
    return null;
  }

  return <MountSwitchWithIdContainer id={id} />;
};

export default MountSwitchContainer;
